<app-esqueleto-tableros>
  <div titulo class="encabezadosSeparacion"
    [matTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)"
    [appOverflowTooltip]="('menu.'+ dataService.moduleSelect | translate) +' &bull; '+ ('menu.'+ dataService.subModuleSelect | translate)">
    <span class="headerCintilla1">{{ "menu." + dataService.moduleSelect | translate }}</span>
    <span class="bullSeparation">&bull;</span>
    <span class="headerCintilla2">{{ "menu." + dataService.subModuleSelect | translate }}</span>
  </div>

  <div contenido class="contenidoClass">
    <div class="encabezado">
      <mat-icon class="iconoMen" [ngStyle]="{'color':'gray'}"
        [matMenuTriggerFor]="menu2">more_vert</mat-icon>
      <mat-menu #menu2="matMenu">
        <button (click)="exportar_excel()" class="mat-menu-item" mat-menu-item class="w3-caja-menu">
          <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
          <span> {{'gestion.formulacion.matRiesOport.export'|translate}} </span>
        </button>
        <button (click)="ponderacionAutomatica()" class="mat-menu-item" mat-menu-item
          class="w3-caja-menu">
          <mat-icon [ngStyle]="{'color':'gray'}">description</mat-icon>
          <span>
            {{'gestion.formulacion.objetivos.ponderacionAutom'|translate}}
          </span>
        </button>
      </mat-menu>
    </div>

    <div id="objetivos_formulacion" class="zonaTablas">
      @if (viewTablero) {
        @for (per of Oobjetivos; track per; let i = $index) {
          <app-contenedor-elementos class="tabla" [header]="{title: per.perspectivaaa.nombre}">
            <div body class="w3-scroll tab">
              <table class="tabla-aleema">
                <thead>
                  <tr>
                    <th style="width:3vw;">
                      #
                    </th>
                    <th>
                      {{'gestion.formulacion.objetivos.formText1' | translate}}
                    </th>
                    <th style="width: 6vw;">
                      {{'gestion.formulacion.objetivos.formText2' | translate}}
                    </th>
                    <th *appRoles="permisos.CARGA_ARCHIVOS" style="width:4vw;">
                      <mat-icon matTooltip="{{'gestion.formulacion.objetivos.tooltip1'|translate}}"
                      (click)="open_modal(per.perspectivaaa)"
                      class="iconoMen colorBotonDeNuevo">add_circle_outline</mat-icon>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  @for (ele of per.objetivosss; track ele; let i = $index) {
                    <tr>
                      <td>O{{i+1}}</td>
                      <td style="max-width: 25vw; overflow: hidden;" [matTooltip]="ele.nombre"
                        [appOverflowTooltip]="ele.nombre">
                        {{ele.nombre}}
                      </td>
                      <td *appRoles="permisos.CARGA_ARCHIVOS"
                        (dblclick)="edicionPond(ele)" style="cursor: pointer;">
                        {{ele.ponderacion}}
                      </td>
                      <td *appRolesNeg="permisos.CARGA_ARCHIVOS">
                        {{ele.ponderacion}} </td>
                      <td *appRoles="permisos.CARGA_ARCHIVOS">
                        <mat-icon class="iconoMen" (click)="open_edit(ele,per.perspectivaaa)"
                          matTooltip="{{'gestion.formulacion.objetivos.tooltip2'|translate}}">edit</mat-icon>
                        <mat-icon class="iconoMen"
                          matTooltip="{{'gestion.formulacion.objetivos.tooltip3'|translate}}"
                          (click)="alertas('eliminar',ele)">delete</mat-icon>
                      </td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </app-contenedor-elementos>
        }
      }@else {
        @for (item of skeleton; track $index) {
          <div style="height: 39vh;">
            <div style="height: 36vh; width: 95%;">
              <app-skeleton-table [columnas]="4" [filas]="6" />
            </div>
          </div>
        }
      }
    </div>
    <!-- </div> -->
  </div>
</app-esqueleto-tableros>

<app-modal [isOpen]="modal" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{ 'gestion.formulacion.objetivos.agregarObj' | translate }}
  </div>
  <div modal-body>
    <form [formGroup]="formNuevo">

      @if(formNuevo.hasError('isValid')) {
      <mat-error class="error-message" style="margin-left: 10%; color: red;">
        {{'gestion.formulacion.objetivos.formText1'|translate}} <strong>
          {{'gestion.formulacion.objetivos.formText3'|translate}}.</strong>
      </mat-error>
      }
      <div class="form-group">
        <label for="nombre" class="form-label">
          {{'gestion.formulacion.objetivos.formText1' | translate}} *
        </label>
        <input type="text" id="nombre" class="form-input anchosInputs" formControlName="inputName"
        [matTooltip]="formNuevo.controls.inputName.value" [appOverflowTooltip]="formNuevo.controls.inputName.value"
          placeholder="{{'gestion.formulacion.objetivos.placeHolderNombre'|translate}}" required>
      </div>
      <div class="form-group">
        <label for="responsable" class="form-label">
          {{'gestion.formulacion.objetivos.formText4' | translate}} *
        </label>
        <select id="responsable" formControlName="inputPerspective" class="contentSelect anchosInputs" required>
          <option value="default" disabled selected>
            {{'gestion.formulacion.objetivos.formText5'|translate}}
          </option>
          @for(res of responsable; track res) {
            <option [value]="res.id"
            [matTooltip]="res.cargo" [appOverflowTooltip]="res.cargo"> {{res.cargo}} </option>
          }
        </select>
      </div>

      <div class="w3-row">
        <div class="w3-rest">
          <div class="form-group">
            <label for="ponderacion" class="form-label">
              {{'gestion.formulacion.objetivos.formText6' | translate}} *
            </label>
            <input type="number" id="ponderacion" class="form-input anchosInputs" formControlName="inputPonderacion"
              placeholder="{{'gestion.formulacion.objetivos.formText7'|translate}}" required>
          </div>
        </div>
      </div>
    </form>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="puede_guardar()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('guardar')"
  />
</app-modal>

<app-modal [isOpen]="modal2" [cerrar]="false" (close)="closeModal()">
  <div modal-header>
    {{ 'gestion.formulacion.objetivos.editarObj' | translate }}
  </div>

  <div modal-body>
    <form [formGroup]="formNuevo">
      @if(formNuevo.hasError('isValid')) {
      <mat-error class="error-message" style="margin-left: 10%; color: red;">
        {{'gestion.formulacion.objetivos.formText1'|translate}} <strong>
          {{'gestion.formulacion.objetivos.formText3'|translate}}.</strong>
      </mat-error>
      }
      <div class="form-group">
        <label for="nombreedit" class="form-label">
          {{'gestion.formulacion.objetivos.formText1' | translate}} *
        </label>
        <input type="text" id="nombreedit" class="form-input anchosInputs" formControlName="inputNameEdit"
          [matTooltip]="formNuevo.controls.inputNameEdit.value" [appOverflowTooltip]="formNuevo.controls.inputNameEdit.value"
          placeholder="{{'gestion.formulacion.objetivos.placeHolderNombre'|translate}}" required>
      </div>

      <div class="form-group">
        <label for="responsable" class="form-label">
          {{'gestion.formulacion.objetivos.formText4' | translate}} *
        </label>
        <select id="responsable" formControlName="inputPerspectiveEdit" class="contentSelect anchosInputs" required>
          <option value="default" disabled selected>
            {{'gestion.formulacion.objetivos.formText5'|translate}}
          </option>
          @for(res of responsable; track res) {
            <option [value]="res.id"
            [matTooltip]="res.cargo" [appOverflowTooltip]="res.cargo"> {{res.cargo}} </option>
          }
        </select>
      </div>

      <div class="w3-row">
        <div class="w3-rest">
          <div class="form-group">
            <label for="ponderacionedit" class="form-label">
              {{'gestion.formulacion.objetivos.formText6' | translate}} *
            </label>
            <input type="number" id="ponderacionedit" class="form-input anchosInputs"
              formControlName="inputPonderacionEdit"
              placeholder="{{'gestion.formulacion.objetivos.formText7'|translate}}" required>
          </div>
        </div>
      </div>

    </form>
  </div>

  <app-button modal-footer
    [color]="'var(--color-cancel)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.cancel' | translate"
    (clickB)="closeModal()"
  />
  <app-button modal-footer
    [ngClass]="puede_guardarEdit()"
    [color]="'var(--color-acept)'"
    [textColor]="'var(--color-text)'"
    [text]="'menu.Guardar' | translate"
    (clickB)="alertas('editar')"
  />
</app-modal>